export default "__VITE_ASSET__DEpSEpzI__"